import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { getTermsAndConditionsUrl } from '@/utils/urls';

const TermsAndConditionsPageHeaderMeta = () => {
    const baseUrl = useAppSelector(getBaseUrl);
    const { formatMessage } = useIntl();
    const description = formatMessage({ id: 'get_in_on_the_auction' });
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'terms_and_conditions' }));
    const canonical = `${baseUrl}${getTermsAndConditionsUrl()}`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default TermsAndConditionsPageHeaderMeta;
